import { useState } from 'react';
import { Header, Button, Link } from 'mondrian-react';
import { useAuth } from '../../../hooks/auth';
import ModalChangePassword from './components/ModalChangePassword';
import styles from './styles.module.css';
import Menu from '../../../components/Menu';

function DefaultLayout({ children }) {
  const { signOut } = useAuth();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Menu noHeader />

      <Header>
        <div className={styles.Header}>
          <Button
            secondaryInverse
            className={styles.HeaderButton}
            onClick={() => setOpenModal(true)}
          >
            <span
              className={`mdn-Icon-atualizar mdn-Icon--md ${styles.ButtonIcon}`}
            />
            Resetar senha
          </Button>
          <Button
            secondaryInverse
            className={styles.HeaderButton}
            onClick={signOut}
          >
            <span
              className={`mdn-Icon-sair mdn-Icon--md ${styles.ButtonIcon}`}
            />
            Sair
          </Button>
        </div>
      </Header>

      <div className={`mdn-Container-fluid ${styles['mdn-Container-fluid']}`}>
        {children}
      </div>

      <div className={`mdn-Container ${styles.FooterLinks}`}>
        <div className={styles.FooterLinksWrapper}>
          <img
            src="https://mondrian.claro.com.br/brands/horizontal/default/beon.svg"
            alt=""
          />

          <Link
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=S30kVTW0pUeIG8p2J0NOeYsid-bq8fFCmxjF-wCXjBFUMEdaRE9JSUNZVFJMTVhGWUZQSUZWQjNMRy4u"
            className={`mdn-Link mdn-Link-anchor ${styles.FooterLinkFeedback}`}
            target="_blank"
          >
            Feedback
          </Link>
        </div>
      </div>
      <footer
        className="mdn-Footer mdn-Footer--simple mdn-Footer--signature mdn-Footer--bottom"
        role="contentinfo"
      >
        <div className="mdn-Container">
          <div className="mdn-Footer-content">
            <div className="mdn-Footer-disclaimer">
              <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                <strong>
                  © 2020-2021 Claro. Todos os direitos reservados.
                </strong>
              </p>
            </div>
            <div className="mdn-Footer-logo">
              <img
                className="mdn-Footer-logo-image"
                src="https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png"
                alt="Logo Claro"
              />
            </div>
          </div>
        </div>
      </footer>

      <ModalChangePassword open={openModal} close={() => setOpenModal(false)} />
    </>
  );
}

export default DefaultLayout;
